var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-tooltip"},[_c('eui-tooltip',{staticClass:"item",attrs:{"content":_vm.content,"placement":_vm.placement,"disabled":_vm.isShowTooltip}},[_c('p',{class:_vm.line === 1 ? 'over-flow-1' : 'over-flow-2',style:({
        width: _vm.tooltipStyle.width,
        color: _vm.tooltipStyle.color,
        fontSize: _vm.tooltipStyle.fontsize,
        cursor: _vm.tooltipStyle.cursor,
      }),on:{"mouseover":function($event){return _vm.onMouseOver(_vm.refName)}}},[_c('span',{ref:_vm.refName},[_vm._v(_vm._s(_vm.content || '-'))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }